import styled, { css } from "styled-components"

import Button from "~/components/Button"
import { componentBackgroundColor } from "~/utilities/styles"

export type Period = "today" | "this-week" | "7-days" | "this-month" | "30-days" | "this-year" | "1-year" | "all-time"

export const periodOptions: { id: Period; label: string }[] = [
	{ id: "today", label: "Today" },
	{ id: "this-week", label: "This week" },
	{ id: "7-days", label: "7 days" },
	{ id: "this-month", label: "This month" },
	{ id: "30-days", label: "30 days" },
	{ id: "this-year", label: "This year" },
	{ id: "1-year", label: "1 year" },
	{ id: "all-time", label: "All time" },
]

const PeriodSelector: React.FC<{ selectedValue: Period; onChange: (newValue: Period) => void }> = ({
	selectedValue,
	onChange,
}) => (
	<Container>
		{periodOptions.map(({ id, label }, index) => (
			<Option key={index} isActive={id === selectedValue} onClick={() => onChange(id)}>
				{label}
			</Option>
		))}
	</Container>
)

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	background-color: ${componentBackgroundColor};
	padding: 6px;
	border-radius: 12px;
`

const Option = styled(Button)<{ isActive: boolean }>`
	font-weight: 600;
	font-size: 14px;
	color: #475569;
	text-decoration: none;
	border-radius: 8px;
	padding: 10px 14px;
	transition: background-color 150ms, color 150ms;
	display: flex;
	align-items: center;
	gap: 8px;

	${props =>
		props.isActive &&
		css`
			color: ${props => props.theme.primaryColor};
			background-color: ${props => props.theme.primaryColor}14;
		`}
`

export default PeriodSelector
